import { FC, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import NoneLoginShow from 'elem/compCommon/NoneLoginShow';
import EditorLink from 'lowcode/components/EditorLink';
import IconClose from '../../Teaser/ReferralNext/IconClose';
import styled from './index.module.scss';
import { i18nText } from '@/app/eflayout/Footer/i18nText';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import { signupCookie } from '@/utils/cookies/signupCookie';
interface TheProps {
    callback?: () => void; // 新品订阅
}

const TheComp: FC<TheProps> = ({ callback }) => {
    const { locale } = getLocal();
    const [isClient, setIsClient] = useState(false);
    const textA = i18nText[locale] || i18nText['en'];
    const { t } = useLang('membersday.end.SubscribeEnd');

    useEffect(() => {
        setIsClient(true);
    }, []);

    if (!isClient) {
        return null;
    }

    return ReactDOM.createPortal(
        <div className={`glo-editor-modal glo-editor-modal-show ${styled.endWin}`}>
            <div className="glo-editor-modal-wrap">
                <div className="modal-content">
                    <IconClose
                        className="win-close"
                        onClick={() => {
                            callback && callback();
                        }}
                    />
                    <div className="win-title">
                        {locale === 'za' ? textA.site_bottom_subscription_tip_three : textA.site_bottom_subscription_sms_phone_thank}
                    </div>
                    <div className="win-desc">{t('desc')}</div>
                    <NoneLoginShow>
                        <EditorLink
                            href={`/${locale}/register?redirect=/${locale}/members-day`}
                            className="win-btn"
                            onClick={() => {
                                signupCookie?.({
                                    sector_name: locale === 'za' ? textA.site_bottom_subscription_tip_three : textA.site_bottom_subscription_sms_phone_thank,
                                    entry_position: 3,
                                });
                            }}
                        >
                            {t('btn')}
                        </EditorLink>
                        <div className="win-line">
                            {t('tips1')}
                            <EditorLink
                                href={`/${locale}/login?redirect=/${locale}/members-day`}
                                onClick={() => {
                                    signupCookie?.({
                                        sector_name:
                                            locale === 'za' ? textA.site_bottom_subscription_tip_three : textA.site_bottom_subscription_sms_phone_thank,
                                        entry_position: 3,
                                    });
                                }}
                            >
                                {t('tips2')}
                            </EditorLink>
                        </div>
                    </NoneLoginShow>
                </div>
            </div>
        </div>,
        document.body,
    );
};

export default TheComp;
